
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const TOTAL_LOGOS = 51;

function SliderEmpresas() {
  return (
    <Swiper
      modules={[Navigation, Pagination, A11y, Autoplay]}
      spaceBetween={8}
      slidesPerView={4}
      slidesPerGroup={1}
      navigation
      pagination={{ clickable: true }}
      loop
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      speed={650}
      breakpoints={{
        0: { slidesPerView: 2 },
        480: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      }}
    >
      {Array.from({ length: TOTAL_LOGOS }, (_, i) => i + 1).map((n) => (
        <SwiperSlide key={n}>
          <img
            src={`/${n}.webp`}
            alt={`Empresa anunciante ${n}`}
            className="ed-logo-empresa"
            loading="lazy"
            decoding="async"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default SliderEmpresas;
